import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const steps = ["Address", "Oreder Summary", "Payment"];
const ADDRESS_STORAGE_KEY = "savedAddress";

function Address() {
  const navigate = useNavigate();

  const location = useLocation();

  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    pincode: "",
    city: "",
    state: "",
    house: "",
    road: "",
  });

  useEffect(() => {
    try {
      const savedAddress = localStorage.getItem(ADDRESS_STORAGE_KEY);
      if (!savedAddress) return;

      const parsedAddress = JSON.parse(savedAddress);
      if (parsedAddress && typeof parsedAddress === "object") {
        setFormData((prev) => ({ ...prev, ...parsedAddress }));
      }
    } catch (error) {
      console.error("Unable to load saved address:", error);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let nextValue = value;
    if (name === "mobile") {
      nextValue = value.replace(/\D/g, "").slice(0, 10);
    } else if (name === "pincode") {
      nextValue = value.replace(/\D/g, "").slice(0, 6);
    }

    setFormData({ ...formData, [name]: nextValue });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const requiredFields = [
      "fullName",
      "mobile",
      "pincode",
      "city",
      "state",
      "house",
      "road",
    ];
    const emptyFields = requiredFields.filter((field) => !formData[field]);

    if (emptyFields.length > 0) {
      alert("Please fill all required fields before proceeding.");
      return;
    }

    console.log("Address Saved:", formData);
    localStorage.setItem(ADDRESS_STORAGE_KEY, JSON.stringify(formData));

    const cart = location.state?.cart || [];
    const product = location.state?.product;

    navigate("/order-summary", {
      state: {
        address: formData,
        cart: cart.length > 0 ? cart : product ? [product] : [],
      },
    });
  };

  return (
    <div
      className="container"
      style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        padding: "16px 12px 92px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "16px",
          borderRadius: "16px",
          maxWidth: "420px",
          margin: "0 auto",
          boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
        }}
      >
        <div
          style={{
            maxWidth: "400px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <button
            onClick={() => navigate(-1)}
            style={{
              fontSize: "18px",
              marginRight: "10px",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2 style={{ fontSize: "16px", fontWeight: "600" }}>
            Add delivery address
          </h2>
        </div>

        <Box sx={{ width: "100%" }}>
          <Stepper activeStep={0} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Box
          component="form"
          sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
          style={{
            maxWidth: "400px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            width: "100%",
          }}
        >
          <TextField
            id="outlined-basic"
            name="fullName"
            label="Full Name"
            variant="outlined"
            value={formData.fullName}
            onChange={handleChange}
            required
            style={{ width: "95%" }}
          />
          <TextField
            id="outlined-basic-mobile"
            name="mobile"
            label="Mobile Number"
            variant="outlined"
            type="tel"
            value={formData.mobile}
            onChange={handleChange}
            required
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              maxLength: 10
            }}
            slotProps={{
              htmlInput: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 10
              }
            }}
            style={{ width: "95%" }}
          />
          <TextField
            id="outlined-basic-pincode"
            name="pincode"
            label="Pincode"
            variant="outlined"
            type="tel"
            value={formData.pincode}
            onChange={handleChange}
            required
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              maxLength: 6
            }}
            slotProps={{
              htmlInput: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 6
              }
            }}
            style={{ width: "95%" }}
          />
          <div style={{ display: "flex", gap: "10px", width: "100%", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <TextField
                id="outlined-basic"
                name="city"
                label="City"
                variant="outlined"
                value={formData.city}
                onChange={handleChange}
                required
                style={{ width: "100%" }}
              />
            </div>

            <FormControl style={{ flex: 1, width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                State Required*
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="state"
                id="demo-simple-select"
                value={formData.state}
                label="State Required*"
                onChange={handleChange}
                style={{ width: "100%" }}
              >
                <MenuItem value={0}>Andhra Pradesh</MenuItem>
                <MenuItem value={1}>Arunachal Pradesh</MenuItem>
                <MenuItem value={2}>Assam</MenuItem>
                <MenuItem value={3}>Bihar</MenuItem>
                <MenuItem value={4}>Chhattisgarh</MenuItem>
                <MenuItem value={5}>Goa</MenuItem>
                <MenuItem value={6}>Gujarat</MenuItem>
                <MenuItem value={7}>Haryana</MenuItem>
                <MenuItem value={8}>Himachal Pradesh</MenuItem>
                <MenuItem value={9}>Jharkhand</MenuItem>
                <MenuItem value={10}>Karnataka</MenuItem>
                <MenuItem value={11}>Kerala</MenuItem>
                <MenuItem value={12}>Madhya Pradesh</MenuItem>
                <MenuItem value={13}>Maharashtra</MenuItem>
                <MenuItem value={14}>Manipur</MenuItem>
                <MenuItem value={15}>Meghalaya</MenuItem>
                <MenuItem value={16}>Mizoram</MenuItem>
                <MenuItem value={17}>Nagaland</MenuItem>
                <MenuItem value={18}>Odisha</MenuItem>
                <MenuItem value={19}>Punjab</MenuItem>
                <MenuItem value={20}>Rajasthan</MenuItem>
                <MenuItem value={21}>Sikkim</MenuItem>
                <MenuItem value={22}>Tamil Nadu</MenuItem>
                <MenuItem value={23}>Telangana</MenuItem>
                <MenuItem value={24}>Tripura</MenuItem>
                <MenuItem value={25}>Uttar Pradesh</MenuItem>
                <MenuItem value={26}>Uttarakhand</MenuItem>
                <MenuItem value={27}>West Bengal</MenuItem>
              </Select>
            </FormControl>
          </div>
          <TextField
            id="outlined-basic"
            name="house"
            label="House No., Building Name"
            variant="outlined"
            value={formData.house}
            onChange={handleChange}
            required
            style={{ width: "95%" }}
          />
          <TextField
            id="outlined-basic"
            name="road"
            label="Road name, Area, Colony"
            variant="outlined"
            value={formData.road}
            onChange={handleChange}
            required
            style={{ width: "95%", marginBottom: "60px" }}
          />

          <button
            type="submit"
            style={{
              background: "rgb(255, 140, 0)",
              color: "rgb(255, 255, 255)",
              position: "fixed",
              bottom: "12px",
              left: "50%",
              transform: "translateX(-50%)",
              padding: "13px 18px",
              border: "none",
              borderRadius: "10px",
              fontWeight: "600",
              cursor: "pointer",
              width: "calc(100% - 24px)",
              maxWidth: "380px",
              boxShadow: "0 10px 24px rgba(255, 140, 0, 0.25)",
            }}
          >
            Save Address
          </button>
        </Box>
      </div>
    </div>
  );
}

export default Address;
